import { parseDateInput } from '../date-format.js';

/** Split a CSV date cell that may contain a range (Notion-style arrows, etc.). */
const DATE_RANGE_SEP = /\s*(?:\.\.|→|->|—|–)\s*/u;

export function splitImportDateRange(text: string): string[] {
  const trimmed = text.trim();
  if (!trimmed) {
    return [];
  }
  const parts = trimmed.split(DATE_RANGE_SEP).map((p) => p.trim()).filter(Boolean);
  return parts.length > 0 ? parts : [trimmed];
}

/** Parse currency / formatted numeric strings from CSV (e.g. "$200.00", "1,234.5"). */
export function parseImportNumber(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  const cleaned = trimmed.replace(/[$€£¥]/g, '').replace(/,/g, '').trim();
  if (!cleaned) {
    return null;
  }
  const n = Number(cleaned);
  return Number.isNaN(n) ? null : n;
}

export function parseImportDateRange(
  text: string,
): { start: string; end: string | null } | null {
  const parts = splitImportDateRange(text);
  if (parts.length === 0) {
    return null;
  }
  const start = parseDateInput(parts[0]!);
  if (!start) {
    return null;
  }
  const end =
    parts.length > 1 && parts[1] ? parseDateInput(parts[1]) : null;
  return { start, end };
}
